import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-9632cdaa"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "h"
  }, null, -1);
});
var _hoisted_2 = {
  "class": "lotteryMain"
};
var _hoisted_3 = {
  "class": "livebox"
};
var _hoisted_4 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "livenav"
  }, [/*#__PURE__*/_createElementVNode("span", {
    "class": "mhide"
  }, "開獎視頻"), /*#__PURE__*/_createElementVNode("div", {
    "class": "livePledge"
  }, [/*#__PURE__*/_createElementVNode("b", null, " 即時開獎驗證"), /*#__PURE__*/_createElementVNode("p", null, "開獎現場直播，同步播報中央電視臺1套視頻，開獎過程100%公開公正！")])], -1);
});
var _hoisted_5 = {
  "class": "sub-nav"
};
var _hoisted_6 = {
  key: 0,
  "data-v-dcdb1798": "",
  "class": "hot"
};
var _hoisted_7 = {
  "class": "liveTop"
};
var _hoisted_8 = {
  "class": "liveBox"
};
var _hoisted_9 = {
  "class": "liveVideo"
};
var _hoisted_10 = {
  "class": "main-page-full"
};
var _hoisted_11 = {
  "class": "hisHeader"
};
var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    "class": "hisHunt"
  }, [/*#__PURE__*/_createElementVNode("h3", {
    "class": "d"
  }, "澳門六合彩 開獎視頻 "), /*#__PURE__*/_createElementVNode("h3", {
    "class": "s"
  }, "開獎視頻")], -1);
});
var _hoisted_13 = {
  "class": "hisFilter"
};
var _hoisted_14 = {
  "class": "hisSearch"
};
var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1025 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor"
  }, [/*#__PURE__*/_createElementVNode("path", {
    d: "M1023.426 964.706L808.421 750.061a456.425 456.425 0 1 0-59.024 58.768l215.004 214.749c1.946 1.946 10.24-3.02 18.276-11.16l29.435-29.384c8.242-8.242 13.259-16.38 11.314-18.326zm-565.77-134.171a373.699 373.699 0 1 1 374.467-373.699 374.109 374.109 0 0 1-374.468 373.699z"
  })], -1);
});
var _hoisted_16 = {
  "class": "hisWrapper"
};
var _hoisted_17 = {
  "class": "liveHisList"
};
var _hoisted_18 = ["onClick"];
var _hoisted_19 = {
  "class": "liveThumb"
};
var _hoisted_20 = {
  key: 0,
  "data-v-1bc3c0f3": "",
  src: "https://00853six.com/assets/repeat-25fbfe0d.png"
};
var _hoisted_21 = {
  key: 1,
  "data-v-1bc3c0f3": "",
  src: "/oldam_video.jpg"
};
var _hoisted_22 = {
  "class": "liveDesc"
};
var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "澳門六合彩", -1);
});
var _hoisted_24 = {
  "data-v-1bc3c0f3": ""
};
import zibo from '@/components/zibo.vue';
import plaues from '@/components/playes.vue';
import { record } from '@/utils/https.js';
import axios from "axios"; //原生的axios

export default {
  __name: 'live',
  setup: function setup(__props) {
    var t = new Date().getTime();
    var toLink = reactive([{
      name: ' 開獎視頻 ',
      path: '/live'
    }
    //  {name:'  資料區  ',path:'/live'},
    ]);

    var type_code = process.env.VUE_APP_TYPE_CODE;
    var videoShow = ref(false);
    var fiveArray = reactive([]);
    var fivedata = ref([]);
    var codeArray = reactive({});
    var period = ref('');
    var inputFunc = function inputFunc(e) {
      console.log(period);
      records('', '', period.value);
      fiveArray = [];
    };
    var newCode = ref({});
    onBeforeMount(function () {
      var url1 = "https://kj6.kkjj.finance/data/v_" + process.env.VUE_APP_TYPE_NAME + ".json?" + t;
      axios(url1).then(function (res) {
        var data = res.data;
        data.Time = data.Time.replace('点', ':').replace('分', '');
        newCode.value = data;
      });
      records();
    });
    var records = function records() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      record({
        lottery_id: process.env.VUE_APP_TYPE_CODE,
        start_time: start,
        end_time: end,
        periods: period
      }).then(function (res) {
        var data = res.data.data;
        if (data.length == 0) {
          fiveArray.length = [];
        } else {
          fiveArray.length = [];
          fivedata.value = data[0];
          data.forEach(function (item, i) {
            fiveArray.push(item);
          });
          fiveArray.forEach(function (items) {
            items.open_number = items.open_number.split(',');
            items.sx = items.sx.split(',');
            items.color = items.color.split(',');
          });
        }
      });
    };
    var activeIndex = ref(1);
    var newYear = function newYear(e) {
      activeIndex.value = e;
      var s = newCode.value.Year - 1 + '/01/01 00:00:00';
      var t = newCode.value.Year - 1 + '/12/31 00:00:00';
      records(s, t, '');
      console.log(s, t);
    };
    var oldYear = function oldYear(e) {
      activeIndex.value = e;
      console.log();
      var s = newCode.value.Year + '/01/01 00:00:00';
      var t = newCode.value.Year + '/' + newCode.value.Moon + '/' + newCode.value.Day + ' ' + newCode.value.Time + ':' + '00';
      records(s, t, '');
      console.log(s, t);
    };
    var pclose = function pclose(e) {
      videoShow.value = e;
    };
    var videoBack = function videoBack(e) {
      videoShow.value = true;
      codeArray = e;
    };
    return function (_ctx, _cache) {
      var _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock(_Fragment, null, [_hoisted_1, _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [_createElementVNode("nav", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toLink), function (item, index) {
        return _openBlock(), _createBlock(_component_router_link, {
          to: {
            path: item.path
          },
          key: index,
          "active-class": "router-link-exact-active"
        }, {
          "default": _withCtx(function () {
            return [_createElementVNode("span", null, _toDisplayString(item.name), 1), index == 1 ? (_openBlock(), _createElementBlock("sup", _hoisted_6, "hot")) : _createCommentVNode("", true)];
          }),
          _: 2
        }, 1032, ["to"]);
      }), 128))])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createVNode(zibo)])])]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("ul", _hoisted_13, [_createElementVNode("li", {
        "class": _normalizeClass(_unref(activeIndex) == '1' ? 'active' : ''),
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _unref(newYear)(1);
        })
      }, "今年", 2), _createElementVNode("li", {
        "class": _normalizeClass(_unref(activeIndex) == '2' ? 'active' : ''),
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return _unref(oldYear)(2);
        })
      }, "去年", 2)]), _createElementVNode("div", _hoisted_14, [_withDirectives(_createElementVNode("input", {
        type: "text",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return _isRef(period) ? period.value = $event : period = $event;
        }),
        placeholder: "輸入期號",
        onInput: _cache[3] || (_cache[3] = function () {
          return _unref(inputFunc) && _unref(inputFunc).apply(void 0, arguments);
        }),
        maxlength: "11"
      }, null, 544), [[_vModelText, _unref(period)]]), _hoisted_15])]), _createElementVNode("div", _hoisted_16, [_createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(fiveArray), function (item, index) {
        return _openBlock(), _createElementBlock("div", {
          "class": "liveItem",
          onClick: function onClick($event) {
            return _unref(videoBack)(item);
          },
          key: index
        }, [_createElementVNode("div", _hoisted_19, [_unref(type_code) != 7 ? (_openBlock(), _createElementBlock("img", _hoisted_20)) : _createCommentVNode("", true), _unref(type_code) == 7 ? (_openBlock(), _createElementBlock("img", _hoisted_21)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("span", null, [_createTextVNode("第 "), _createElementVNode("b", _hoisted_24, _toDisplayString(item.year + item.periods), 1), _createTextVNode(" 期 開獎視頻")])])], 8, _hoisted_18);
      }), 128))])])])]), _createVNode(plaues, {
        videoShow: _unref(videoShow),
        onPclose: _unref(pclose),
        codeArray: _unref(codeArray)
      }, null, 8, ["videoShow", "onPclose", "codeArray"])], 64);
    };
  }
};